exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".headerWidget .reviews-header .rating{font-size:30px;color:#ffc834;font-weight:800 !important;display:flex;justify-content:flex-start;align-items:center;flex-direction:row;margin-right:8px}.headerWidget .reviews-header .fdn-rating{font-size:30px;display:inline-block;margin-left:.2em}.headerWidget .reviews-header a{text-decoration:none;display:flex;justify-content:flex-start;align-items:center;flex-direction:row;flex-wrap:wrap}@media only screen and (max-width: 600px){.headerWidget .reviews-header a{justify-content:center}}.headerWidget .reviews-header a.break{flex-direction:column}.headerWidget .reviews-header .link{display:inline-block;color:#404040;text-decoration:underline}.headerWidget .reviews-header .link.dark{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/containers/Header/Header.scss
// module id = 114
// module chunks = 0